import { render, staticRenderFns } from "./goodListNew.vue?vue&type=template&id=2c62070d&scoped=true"
import script from "./goodListNew.vue?vue&type=script&lang=js"
export * from "./goodListNew.vue?vue&type=script&lang=js"
import style0 from "./goodListNew.vue?vue&type=style&index=0&id=2c62070d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c62070d",
  null
  
)

export default component.exports